let regioni =  [
  {
    nome: '',
    calcolo: (imp) => {
      return 0
    }
  },
  {
    nome: "Abruzzo",
    aliquota: "- Fino a €28.000 -> <strong>1,67%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>2,87%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 28000) {
        return imp * 0.0167;
      }
      if (imp > 28000 && imp <= 50000) {
        return 259.5 + (imp - 15000) * 0.0287;
      }
      if (imp > 28000 && imp <= 50000) {
        return 484.4 + (imp - 28000) * 0.0287;
      }
      if (imp > 50000) {
        return 865.0 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Basilicata",
    aliquota: "Aliquota unica: <strong>1,23 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 344.4 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 615.0 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
  {
    nome: "Bolzano",
    aliquota: "- Fino a €28.000 -> <strong>1,23%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,23%</strong><br />- Oltre €50.000 -> <strong>1,73%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        var a = (imp * 0.0123) - 430.5;
        if (a < 0) {
          return 0;
        } else {
          return a
        }
      }
      if (imp > 15000 && imp <= 28000) {
        return (184.5 + (imp - 15000) * 0.0123) - 430.5;
      }
      if (imp > 28000 && imp <= 50000) {
        return (344.4 + (imp - 28000) * 0.0123) - 430.5;
      }
      if (imp > 50000) {
        return (615.0 + (imp - 50000) * 0.0173) - 430.5;
      }
      return 0;
    },
  },
  {
    nome: "Calabria",
    aliquota: "Aliquota unica: <strong>1,73 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0173;
      }
      if (imp > 15000 && imp <= 28000) {
        return 259.5 + (imp - 15000) * 0.0173;
      }
      if (imp > 28000 && imp <= 50000) {
        return 484.4 + (imp - 28000) * 0.0173;
      }
      if (imp > 50000) {
        return 865.0 + (imp - 50000) * 0.0173;
      }
      return 0;
    },
  },
  {
    nome: "Campania",
    aliquota: "- Fino a €15.000 -> <strong>1,73%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>2,96%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,20%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0173;
      }
      if (imp > 15000 && imp <= 28000) {
        return 259.5 + (imp - 15000) * 0.0296;
      }
      if (imp > 28000 && imp <= 50000) {
        return 644.3 + (imp - 28000) * 0.032;
      }
      if (imp > 50000) {
        return 1348.3 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Emilia Romagna",
    aliquota: "- Fino a €15.000 -> <strong>1,33%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,93%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>2,93%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0133;
      }
      if (imp > 15000 && imp <= 28000) {
        return 199.5 + (imp - 15000) * 0.0193;
      }
      if (imp > 28000 && imp <= 50000) {
        return 450.4 + (imp - 28000) * 0.0293;
      }
      if (imp > 50000) {
        return 897.0 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Friuli Venezia Giulia",    
    aliquota: "- Fino a €15.000 -> <strong>0,70%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,23%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,23%</strong><br />- Oltre €50.000 -> <strong>1,23%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.007;
      }
      if (imp > 15000 && imp <= 28000) {
        return 105.0 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 264.9 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 535.5 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
  {
    nome: "Lazio",
    aliquota: "- Fino a €15.000 -> <strong>1,73%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>3,33%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,33%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0173;
      }
      if (imp > 15000 && imp <= 28000) {
        return 259.5 + (imp - 15000) * 0.0333;
      }
      if (imp > 28000 && imp <= 50000) {
        return 692.4 + (imp - 28000) * 0.0333;
      }
      if (imp > 50000) {
        return 1425.0 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Liguria",
    aliquota: "- Fino a €28.000 -> <strong>1,23%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,18%</strong><br />- Oltre €50.000 -> <strong>3,23%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 419.8 + (imp - 28000) * 0.0318;
      }
      if (imp > 50000) {
        return 928.0 + (imp - 50000) * 0.0323;
      }
      return 0;
    },
  },
  {
    nome: "Lombardia",
    aliquota: "- Fino a €15.000 -> <strong>1,23%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,58%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,72%</strong><br />- Oltre €50.000 -> <strong>1,73%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0158;
      }
      if (imp > 28000 && imp <= 50000) {
        return 389.9 + (imp - 28000) * 0.0172;
      }
      if (imp > 50000) {
        return 768.3 + (imp - 50000) * 0.0173;
      }
      return 0;
    },
  },
  {
    nome: "Marche",
    aliquota: "- Fino a €15.000 -> <strong>1,23%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,53%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,70%</strong><br />- Oltre €50.000 -> <strong>1,73%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0153;
      }
      if (imp > 28000 && imp <= 50000) {
        return 383.4 + (imp - 28000) * 0.017;
      }
      if (imp > 50000) {
        return 757.4 + (imp - 50000) * 0.0173;
      }
      return 0;
    },
  },
  {
    nome: "Molise",
    aliquota: "- Fino a €15.000 -> <strong>1,73%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,93%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,33%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0173;
      }
      if (imp > 15000 && imp <= 28000) {
        return 259.5 + (imp - 15000) * 0.0193;
      }
      if (imp > 28000 && imp <= 50000) {
        return 510.4 + (imp - 28000) * 0.0333;
      }
      if (imp > 50000) {
        return 979.0 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Piemonte",
    aliquota: "- Fino a €15.000 -> <strong>1,62%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>2,13%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>2,75%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0162;
      }
      if (imp > 15000 && imp <= 28000) {
        return 243.0 + (imp - 15000) * 0.0213;
      }
      if (imp > 28000 && imp <= 50000) {
        return 519.9 + (imp - 28000) * 0.0275;
      }
      if (imp > 50000) {
        return 1124.9 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Puglia",
    aliquota: "- Fino a €15.000 -> <strong>1,33%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,43%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,63%</strong><br />- Oltre €50.000 -> <strong>1,85%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0133;
      }
      if (imp > 15000 && imp <= 28000) {
        return 199.5 + (imp - 15000) * 0.0143;
      }
      if (imp > 28000 && imp <= 50000) {
        return 385.4 + (imp - 28000) * 0.0163;
      }
      if (imp > 50000) {
        return 744.0 + (imp - 50000) * 0.0185;
      }
      return 0;
    },
  },
  {
    nome: "Sardegna",
    aliquota: "Aliquota unica: <strong>1,23 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 344.4 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 615.0 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
  {
    nome: "Sicilia",
    aliquota: "Aliquota unica: <strong>1,23 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 344.4 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 615.0 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
  {
    nome: "Toscana",
    aliquota: "- Fino a €15.000 -> <strong>1,42%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,43%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,32%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0142;
      }
      if (imp > 15000 && imp <= 28000) {
        return 213.0 + (imp - 15000) * 0.0143;
      }
      if (imp > 28000 && imp <= 50000) {
        return 398.9 + (imp - 28000) * 0.0332;
      }
      if (imp > 50000) {
        return 768.5 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Trento",
    aliquota: "- Fino a €15.000 -> <strong>1,23%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>1,23%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>1,23%</strong><br />- Oltre €50.000 -> <strong>1,73%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 213.0 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 398.9 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 768.5 + (imp - 50000) * 0.0173;
      }
      return 0;
    },
  },
  {
    nome: "Umbria",
    aliquota: "- Fino a €15.000 -> <strong>1,73%</strong> <br />- Oltre €15.000 e fino a €28.000 -> <strong>3,02%</strong> <br />- Oltre €28.000 e fino a €50.000 -> <strong>3,12%</strong><br />- Oltre €50.000 -> <strong>3,33%</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0173;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0302;
      }
      if (imp > 28000 && imp <= 50000) {
        return 395.1 + (imp - 28000) * 0.0312;
      }
      if (imp > 50000) {
        return 762.5 + (imp - 50000) * 0.0333;
      }
      return 0;
    },
  },
  {
    nome: "Valle d'Aosta",
    aliquota: "Aliquota unica: <strong>1,23 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 344.4 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 615.0 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
  {
    nome: "Veneto",
    aliquota: "Aliquota unica: <strong>1,23 %</strong>",
    calcolo: (imp) => {
      if (imp <= 15000) {
        return imp * 0.0123;
      }
      if (imp > 15000 && imp <= 28000) {
        return 184.5 + (imp - 15000) * 0.0123;
      }
      if (imp > 28000 && imp <= 50000) {
        return 344.4 + (imp - 28000) * 0.0123;
      }
      if (imp > 50000) {
        return 615.0 + (imp - 50000) * 0.0123;
      }
      return 0;
    },
  },
];

export default regioni